import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

@Component({
  selector: 'va-action-menu',
  template: `
    <button type="button" mat-icon-button [matMenuTriggerFor]="menu">
      <mat-icon [style.color]="color">{{ icon }}</mat-icon>
    </button>
    <mat-menu #menu="matMenu" x-position="before" y-position="below">
      @for (action of actions; track action) {
        <button type="button" mat-menu-item (click)="actionSelected.emit(action)">
          {{ action }}
        </button>
      }
    </mat-menu>
    `,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatMenuModule],
})
export class VaActionMenuComponent {
  @Input() icon = 'more_vert';
  @Input() color = 'rgba(0,0,0,0.87)';
  @Input() actions: string[];
  @Output() actionSelected = new EventEmitter<string>();
}
